exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.downloadFileIcon[data-v-2761c18e]{\n  font-size: 20px;\n  border: 1px solid gray;\n  border-radius: 40px;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
